/**
 * Lightweight, dependency-free perf-trace helper for the dashboard load path.
 *
 * Opening a dashboard mounts every widget at once; each widget fetches its
 * own indicator data through a shared concurrency limiter and (usually) the
 * request micro-batcher in SIP-CRUD.js. There was no timestamped, step-level
 * trace of where time actually goes for a single dashboard open - queueing
 * behind the concurrency cap, network time, in-process transform work, or
 * waiting to become visible in the viewport all looked the same from the
 * outside. This helper is purely additive diagnostic logging - it does not
 * change any behavior.
 *
 * Every line is tagged "[PERF]" so it's a single filter away from the rest
 * of the console output (e.g. filter DevTools console by "PERF").
 *
 * Keep `meta` small (ids, counts, ms) - never pass full request/response
 * payloads here, or the instrumentation adds its own overhead to the thing
 * it's measuring.
 */
export const perfLog = (stage, meta) => {
	const parts = meta
		? Object.keys(meta)
				.map(key => `${key}=${meta[key]}`)
				.join(" | ")
		: "";
	// eslint-disable-next-line no-console
	console.log(`[PERF] ${new Date().toISOString()} | ${stage}${parts ? ` | ${parts}` : ""}`);
};

export default perfLog;
